/**
 * Utilidad para limpiar caches de la Cache API.
 * No desregistra service workers: eso rompe Web Push (y en desarrollo
 * pelea con el registro del SW real).
 */

export const clearAllCaches = async (options?: { unregisterServiceWorkers?: boolean }): Promise<boolean> => {
  try {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    }

    // Solo bajo pedido explícito (consola / mantenimiento), nunca en el boot normal.
    if (options?.unregisterServiceWorkers && 'serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    return true;
  } catch {
    return false;
  }
};

if (typeof window !== 'undefined') {
  (window as any).clearAllCaches = clearAllCaches;
}







